import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { ROLES } from '../services/permissionService'
import LoadingSpinner from './LoadingSpinner'

const SmartRouteRedirect = () => {
  const { userPermissions, permissionsLoading, permissionsReady, userClaims } = useAuth()
  const location = useLocation()

  // Wait for the current user's access state before honoring a return URL.
  // Firebase supplies the authenticated user before claims and permissions.
  if (!userClaims || permissionsLoading || !permissionsReady) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <LoadingSpinner />
      </div>
    )
  }

  // Check if there's a return URL from a previous redirect (e.g., from login)
  const returnUrl = location.state?.returnUrl
  
  // If there's a returnUrl, redirect there immediately
  if (returnUrl) {
    console.log('SmartRouteRedirect: returnUrl found, redirecting to:', returnUrl)
    return <Navigate to={returnUrl} replace />
  }

  // Super admin or no permissions - go to dashboard
  if (userClaims?.sadmin || !userPermissions) {
    return <Navigate to="/dashboard" replace />
  }

  // Check if user is primarily a replenish worker
  const userRoles = userPermissions.roles || []
  
  // If user ONLY has replenish worker role, redirect to replenish landing
  if (userRoles.length === 1 && userRoles.includes(ROLES.REPLENISH_WORKER)) {
    return <Navigate to="/replenish-worker" replace />
  }

  // If user has replenish worker role plus other roles, give them choice
  if (userRoles.includes(ROLES.REPLENISH_WORKER) && userRoles.length > 1) {
    // For now, default to dashboard - they can access both interfaces
    return <Navigate to="/dashboard" replace />
  }

  // Default: redirect to dashboard
  return <Navigate to="/dashboard" replace />
}

export default SmartRouteRedirect